import { render, staticRenderFns } from "./travelHis.vue?vue&type=template&id=0170b3fe&scoped=true"
import script from "./travelHis.vue?vue&type=script&lang=js"
export * from "./travelHis.vue?vue&type=script&lang=js"
import style0 from "./travelHis.vue?vue&type=style&index=0&id=0170b3fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0170b3fe",
  null
  
)

export default component.exports